export default __webpack_public_path__ + "static/media/technical.cc57c464.svg";